module.exports = __webpack_public_path__ + "static/media/bookmark-outline-selected-icon.e913888b.svg";